import { type QueryHookOptions, QueryResult } from "@apollo/client/react/types/types";
import { FIND_MEMBERS_QUERY } from "../Queries";
import { useQuery } from "@apollo/client";
import { AuthContextProps } from "oidc-react";

export function useMembers(auth?: AuthContextProps, options?: QueryHookOptions): QueryResult {
    const user = auth?.userData;
    const signedIn = !!user;
    return useQuery(FIND_MEMBERS_QUERY, {
        skip: !signedIn,
        ...options
    });
}
